import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=d98fd49a&scoped=true&"
import script from "./CustomList.vue?vue&type=script&lang=js&"
export * from "./CustomList.vue?vue&type=script&lang=js&"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=d98fd49a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98fd49a",
  null
  
)

export default component.exports